/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Injectable } from '@angular/core';
import { BaseApi } from './BaseApi';
import { Observable } from 'rxjs';

@Injectable()
export class BaseTreeStructureApi extends BaseApi {
    public listChildren(parentId?: string, limit?: number, offset: number = 0): Observable<any> {
        let dynamicEndPoint = this.endPoint;
        const _routeParams = {
            parentId: null,
            limit: null,
            offset: 0
        };

        if (parentId == null) {
            dynamicEndPoint = this.endPoint + '/orphan';
            return this._get(dynamicEndPoint, _routeParams);
        }

        dynamicEndPoint += '/:parentId/children';
        _routeParams.parentId = parentId;

        if (limit && limit > 0) {
            _routeParams.limit = limit;
            _routeParams.offset = offset;
            dynamicEndPoint += '/limit/:limit/offset/:offset';
        }

        return this._get(dynamicEndPoint, _routeParams);
    }

}
